<template>
  <FormContainer @submitForm="saveCosto">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome del costo"
        v-model="costo.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Unità di misura"
        v-model="costo.measurementUnit"
        :errorMsg="errorHash['measurementUnit']"
        @input="removeError('measurementUnit')"
      />
    </div>

    <div class="row">
      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Costo unitario"
        v-model.number="costo.unitCost"
        :min="0"
        :errorMsg="errorHash['unitCost']"
        @input="removeError('unitCost')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Aliquota IVA"
        v-model.number="costo.vat"
        :errorMsg="errorHash['vat']"
        @input="removeError('vat')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Ritenuta fiscale"
        v-model.number="costo.ritenuta"
        :errorMsg="errorHash['ritenuta']"
        @input="removeError('ritenuta')"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva voce di costo
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-cost',
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
  },
  props: {
    costo: {
      type: Object,
      default: () => ({
        name: null,
        measurementUnit: null,
        unitCost: null,
        vat: null,
        ritenuta: null,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.costo.name) {
        this.addError('Il nome del costo è obbligatorio', 'name');
      }

      if (!this.costo.measurementUnit) {
        this.addError('L\'unità di misura è obbligatoria', 'measurementUnit');
      }

      if (!this.costo.unitCost && this.costo.unitCost !== 0) {
        this.addError('Il costo unitario è obbligatorio', 'unitCost');
      }

      if (!this.costo.vat && this.costo.vat !== 0) {
        this.addError('Indicare l\'aliquota IVA', 'vat');
      }

      if (!this.costo.ritenuta && this.costo.ritenuta !== 0) {
        this.addError('Indicare l\'aliquota della ritenuta fiscale', 'ritenuta');
      }

      return !this.hasErrors;
    },
    saveCosto () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.costo);
    },
  },
};

</script>
